import { UdioWrapperConfig } from '../types';
import { UdioWrapper } from '../core/wrapper';
import { createBrowserUdioWrapper } from './browser';
import { createNodeUdioWrapper } from './node';

export async function createUdioWrapper(
    authToken: string,
    config: UdioWrapperConfig = {}
): Promise<UdioWrapper> {
    const isBrowser = typeof window !== 'undefined' && window.fetch;

    if (isBrowser) {
        return createBrowserUdioWrapper(authToken, config);
    } else {
        return createNodeUdioWrapper(authToken, config);
    }
}